module.exports = __webpack_public_path__ + "img/img12.8e415ac8.svg";